<script lang="ts">
  // Chips for the other report types that also apply to this activity: a breakthrough on a
  // workout report, a group ride on a breakthrough report, and so on. Each is a "Badges" field.
  import { MEDAL_COLORS, type ReportContext } from '../context'
  import type { ReportType } from '../types'
  import Icon from './Icon.svelte'

  export let ctx: ReportContext
  export let own: ReportType
  export let size: 'md' | 'lg' = 'md'
  // Tight layouts show at most this many (in the order below), so chips never wrap off the image.
  export let max = Infinity

  type Chip = { icon: string, text: string, color?: string }

  $: d = ctx.data
  $: chips = (() => {
    const out: Chip[] = []
    if (own !== 'breakthrough' && d.breakthrough && ctx.show('badge.breakthrough')) {
      const m = MEDAL_COLORS[d.breakthrough.level]
      out.push({ icon: 'award', text: `${m.label} Breakthrough`, color: m.main })
    }
    if (own !== 'group' && d.group && ctx.show('badge.group')) {
      const s = d.group.session
      const r = d.group.ride
      if (s) out.push({ icon: 'users', text: s.rank ? `${ctx.fmt.ordinal(s.rank)} of ${s.participants} · ${s.name}` : `Group session · ${s.participants} riders` })
      else if (r) out.push({ icon: 'users', text: r.squad ? `${r.squad} group ride` : `Group ride · ${r.riders_total + 1} riders` })
    }
    if (own !== 'xfai' && d.xfai && ctx.show('badge.xfai')) {
      out.push({ icon: 'sparkles', text: d.xfai.day && d.xfai.days_total ? `Forecast AI · Day ${d.xfai.day}/${d.xfai.days_total}` : 'Forecast AI plan' })
    }
    if (own !== 'workout' && d.workout && ctx.show('badge.workout')) {
      out.push({ icon: 'pulse', text: d.workout.name })
    }
    return out.slice(0, max)
  })()
</script>

{#if chips.length}
  <div class="xr-badges" class:xr-lg={size === 'lg'}>
    {#each chips as chip}
      <span class="xr-chip" style={chip.color ? `--chip: ${chip.color};` : ''}>
        <Icon name={chip.icon} size={size === 'lg' ? 28 : 24} stroke={2.4} color={chip.color ?? 'currentColor'} />
        <span class="xr-text">{chip.text}</span>
      </span>
    {/each}
  </div>
{/if}

<style>
  .xr-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  .xr-chip {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    max-width: 100%;
    padding: 9px 18px 9px 14px;
    border-radius: 999px;
    background: var(--panel);
    border: 2px solid var(--chip, var(--faint));
    font-size: 22px;
    font-weight: 600;
    white-space: nowrap;
  }
  .xr-lg .xr-chip {
    font-size: 26px;
    padding: 11px 22px 11px 16px;
  }
  .xr-text {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 560px;
  }
</style>
